<template>
  <div class="card-deck">
    <div class="col-lg-12 mb-5">
      <div class="text-center text-lg-right">
        <base-button
          class="mb-3"
          type="white"
          title="'Gerenciar parcerias'"
          @click="$router.push('/startup/beneficios-aceleradas')"
          ><i class="fas fa-handshake text-success mr-2"></i> Benefícios
          aceleradas Stars</base-button
        >
      </div>
    </div>
    <div
      class="col-lg-4 col-md-6 mb-5 mb-lg-3 d-flex align-items-stretch"
      v-for="batch in data"
      :key="batch.id"
    >
      <div class="card card-profile shadow flex-grow-1">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="card-profile-image">
              <img src="/img/pages/batch.png" class="rounded-circle" />
            </div>
          </div>
        </div>
        <div class="card-header text-center border-0 mt-2">
          <div class="d-flex justify-content-right"></div>
        </div>
        <div class="card-body mt-3">
          <div class="text-center mt-5">
            <h2 class="text-center tag-title">
              <span class="tag text-warning">{{ batch.name }}</span>
            </h2>
            <div class="row mt-md-3 mb-2">
              <div class="col text-center text-muted">
                Batch de
                <span class="font-weight-bold">{{ batch.type }}</span>
              </div>
            </div>
            <h3>
              Duração:
              <span class="font-weight-light">
                {{ formatDate(batch.start_date, "L") || "..." }}
                até
                {{ formatDate(batch.end_date, "L") || "..." }}
              </span>
            </h3>
          </div>
        </div>
        <div class="card-footer text-center">
          <base-button
            type="info"
            :custom="true"
            class="mt-2"
            icon="fas fa-clipboard-list"
            :icon-only="true"
            @click="handleViewTasks(batch.id)"
            title="Acompanhamento"
          ></base-button>
          <base-button
            type="warning"
            :custom="true"
            :icon-only="true"
            icon="fas fa-rocket"
            title="Startups participantes"
            class="mt-2"
            @click="handleViewStartups(batch.id)"
          ></base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "batch-list",
  props: {
    data: {
      type: Array,
      default: () => [],
      description: "Batches data",
    },
  },
  methods: {
    handleViewTasks(batchId) {
      this.$router.push(`/startup/batches/${batchId}/acompanhamento`);
    },
    handleViewStartups(batchId) {
      this.$router.push(`/startup/batches/${batchId}/startups`);
    },
  },
};
</script>
<style scoped>
.card {
  margin-top: 10px;
}
.card-profile-image img {
  width: 180px;
  height: 180px;
}
</style>
